import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SendAdharOTPServices } from "../../services/index";
import { setAdharMsg } from "../../redux/slices/abhaSlice";

const AdharNumber = ({
  setAdharNumber,
  setSendOtpFunction,
  setAdharNumbers,
}) => {
  const [checkbox1Checked, setCheckbox1Checked] = useState(false);
  const [checkbox2Checked, setCheckbox2Checked] = useState(false);
  const [inputs, setInputs] = useState({
    input1: "",
    input2: "",
    input3: "",
  });
  const [aNumber, seaNumber] = useState("");
  const dispatch = useDispatch();

  const moveToNextInput = (nextInputId) => {
    const currentInput = document.activeElement;
    if (currentInput.value.length === 4) {
      document.getElementById(nextInputId).focus();
    }
  };
  const handleBackspace = (event, prevInputId) => {
    const currentInput = document.activeElement;
    if (currentInput.value === "" && event.key === "Backspace") {
      document.getElementById(prevInputId).focus();
    }
  };
  const aadharNumber = aNumber.length > 9;
  const handleInputChange = (event, inputId) => {
    const { value } = event.target;
    setInputs((prevState) => ({
      ...prevState,
      [inputId]: value,
    }));
    const aadharinputNumber = `${inputs.input1}${inputs.input2}${inputs.input3}`;

    seaNumber(aadharinputNumber);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const adharNumber = `${inputs.input1}${inputs.input2}${inputs.input3}`;
    localStorage.setItem("lastAadharnumber", inputs.input3);
    if (adharNumber.length === 12) {
      if (adharNumber) {
        SendAdharOtp(adharNumber);
      } else {
        alert("Please enter a valid 4-digit OTP.");
      }
    }
  };

  const SendAdharOtp = async (adharNumber) => {
    try {
      const body = {
        aadhaarNumber: adharNumber,
      };
      const response = await SendAdharOTPServices({ body });
      if (response.status) {
        console.log("OTP sent successfully");
        setAdharNumber(true);
        console.log("OTP sent test");
        const txnId = response.result.txnId;
        const msg = response?.result?.message;
        dispatch(setAdharMsg(msg));
        localStorage.setItem("txnId", txnId);
        const body = { aadhaarNumber: adharNumber };
        setAdharNumbers(body);
        setSendOtpFunction(() => () => SendAdharOtp(adharNumber));
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  // console.log("object", aadharNumber);

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Enter Aadhaar Details to Create/Link ABHA</h3>
                <p className="pt-3">
                  OTP Will Be Sent to The Mobile Number Linked
                </p>
                <form onSubmit={handleSubmit} className="pt-3">
                  {/* <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12"> */}
                  <div className="aadhar-input d-flex justify-center pt-1">
                    <input
                      className="adhar-input text-center"
                      type="text"
                      maxLength="4"
                      pattern="\d{4}"
                      title="Please enter 4 digits"
                      placeholder="XXXX"
                      id="input1"
                      onInput={() => moveToNextInput("input2")}
                      value={inputs.input1}
                      onChange={(event) => handleInputChange(event, "input1")}
                      required
                    />
                    <input
                      className="adhar-input text-center ms-3"
                      type="text"
                      maxLength="4"
                      pattern="\d{4}"
                      title="Please enter 4 digits"
                      placeholder="XXXX"
                      id="input2"
                      onInput={() => moveToNextInput("input3")}
                      onKeyDown={(event) => handleBackspace(event, "input1")}
                      value={inputs.input2}
                      onChange={(event) => handleInputChange(event, "input2")}
                      required
                    />
                    <input
                      className="adhar-input text-center ms-3"
                      type="text"
                      maxLength="4"
                      pattern="\d{4}"
                      title="Please enter 4 digits"
                      placeholder="XXXX"
                      id="input3"
                      onKeyDown={(event) => handleBackspace(event, "input2")}
                      value={inputs.input3}
                      onChange={(event) => handleInputChange(event, "input3")}
                      required
                    />
                  </div>
                  {/* </div> */}
                  <div className="d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input checkbox-color"
                      id="flexCheckDefault"
                      checked={checkbox1Checked}
                      onChange={() => setCheckbox1Checked(!checkbox1Checked)}
                    />
                    <label
                      className="form-check-label ps-2 mb-2"
                      htmlFor="flexCheckDefault"
                    >
                      I Agree to{" "}
                      <a className="resend-otp" href="#">
                        Terms & Conditions
                      </a>{" "}
                      And{" "}
                      <a className="resend-otp" href="#">
                        Privacy Policy
                      </a>{" "}
                      Dr Lal Pathlabs to Create/Link My ABHA Address.
                    </label>
                  </div>
                  <div className="d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input checkbox-click"
                      id="flexCheckDefaultNHA"
                      checked={checkbox2Checked}
                      onChange={() => setCheckbox2Checked(!checkbox2Checked)}
                    />
                    <label
                      className="form-check-NHA ps-2 mb-2"
                      htmlFor="flexCheckDefaultNHA"
                    >
                      I Agree to{" "}
                      <a className="resend-otp" href="#">
                        Terms & Conditions
                      </a>{" "}
                      Approved By the NHA{" "}
                    </label>
                  </div>
                  <button
                    type="submit"
                    className={`continue-btn nha-adhar continue-btn ${
                      !aadharNumber || !checkbox1Checked || !checkbox2Checked
                        ? "bg-disable"
                        : ""
                    }`}
                    disabled={
                      !aadharNumber || !checkbox1Checked || !checkbox2Checked
                    }
                  >
                    Continue
                  </button>
                  <a className="abha-address ps-2" href="#">
                    I Already have Abha Number / ABHA Address
                  </a>{" "}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdharNumber;
